export default class Rule {
  /**
   *
   * @param {string} ruleText
   * @param {string} attribute
   * @param {boolean} active
   */
  constructor(ruleText, attribute, active) {
    this.ruleText = ruleText;
    this.attribute = attribute;
    this.ruleType = 'UNSPECIFIED';
    this.active = active;
  }
  run(input) {
    return input;
  }
  getDisplayText() {
    return this.ruleText;
  }

  getIndex() {
    return this.index;
  }
  setIndex(index) {
    this.index = index;
  }
  getAttribute() {
    return this.attribute;
  }
  getActive() {
    return this.active || this.active !== undefined;
  }
  setActive(active) {
    this.active = active;
  }
  getRuleType() {
    return this.ruleType;
  }
  validate() {
    return true;
  }
}
